module.exports = "<sub-menu *ngIf=\"!isAdmin()\" [menu]=\"menu\"></sub-menu>\n<router-outlet></router-outlet>\n"